const Vue = require('vue')
const { plural } = require('sci/utils')
const R = require('ramda')

const proxy = (obj) => {
    return R.mapObjIndexed((value, key) => {
        return function () {
            // console.trace({ key, arguments: arguments })
            return value.apply(this, arguments)
        }
    }, obj)
}

/**
 * Não use Array.push
 * @returns {*}
 */
module.exports = function (onlyPage = false) {
    return new Vue({
        data () {
            return {
                state: {
                    total: 0,
                    registered: [],
                    selected: [],
                    except: [],
                    all: false
                },
                onlyPage
            }
        },
        ready () {
        },
        computed: {
            allPipe: {
                get () {
                    return this.isAllSelected()
                },
                set (value) {
                    if (this.onlyPage) {
                        if (value) {
                            return this.checkVisible()
                        } else {
                            return this.uncheckVisible()
                        }
                    } else {
                        if (value) {
                            return this.checkAll()
                        } else {
                            return this.checkNone()
                        }
                    }
                }
            },
            countLabel () {
                if (this.state.all) {
                    if (this.state.except.length) {
                        const length = plural(this.state.except.length, '%s item', '%s items')
                        return `Todos, exceto ${length}`
                    }

                    return 'Todos'
                }

                return this.state.selected.length
            },
            count () {
                if (this.state.all) {
                    return this.state.total - this.state.except.length
                }

                return this.state.selected.length
            }
        },
        methods: proxy({
            register (id) {
                this.state.registered = R.uniq([...this.state.registered, id])
            },
            deregister (id) {
                this.state.registered = R.uniq(this.state.registered.filter(_ => _ !== id))
            },
            has (id) {
                if (this.state.all) {
                    return true
                }

                const selected = this.state.selected.indexOf(id) > -1

                if (selected) {
                    return true
                }

                const removed = this.state.except.indexOf(id) > -1

                if (removed) {
                    return false
                }

                return this.state.all
            },
            check (id) {
                if (Array.isArray(id)) {
                    if (!this.state.all) {
                        this.state.selected = R.uniq([...this.state.selected, ...id])
                    } else {
                        this.state.except = R.uniq(this.state.except.filter(i => id.indexOf(i) < 0))
                    }

                    this.$emit(`checked-many`, id)
                } else {
                    if (!this.state.all) {
                        this.state.selected = R.uniq([...this.state.selected, id])
                    } else {
                        this.state.except = R.uniq(this.state.except.filter(_ => _ !== id))
                    }

                    this.$emit(`checked`, id)
                }

                this.$emit('state-changed')
            },
            uncheck (id) {
                if (Array.isArray(id)) {
                    if (this.state.all) {
                        this.state.except = R.uniq([...this.state.except, ...id])
                    } else {
                        this.state.selected = R.uniq(this.state.selected.filter(i => id.indexOf(i) < 0))
                    }

                    this.$emit(`unchecked-many`, id)
                } else {
                    if (this.state.all) {
                        this.state.except = R.uniq([...this.state.except, id])
                    } else {
                        this.state.selected = R.uniq(this.state.selected.filter(_ => _ !== id))
                    }

                    this.$emit(`unchecked`, id)
                }

                this.$emit('state-changed')
            },
            checkAll () {
                this.state.except = []
                this.state.selected = []
                this.state.all = true

                this.$emit(`check`)

                this.$emit('state-changed')
            },
            checkNone () {
                this.state.except = []
                this.state.selected = []
                this.state.all = false

                this.$emit(`uncheck`)

                this.$emit('state-changed')
            },
            checkVisible () {
                this.$emit(`check-if-visible`)
            },
            uncheckVisible () {
                this.$emit(`uncheck-if-visible`)
            },
            toggle (id) {
                if (this.has(id)) {
                    this.uncheck(id)
                } else {
                    this.check(id)
                }
            },
            toggleVisible () {
                this.$emit(`toggle-if-visible`)
            },
            toggleAll () {
                this.state.except = []
                this.state.selected = []

                this.state.all = !this.state.all

                if (!this.state.all) {
                    this.$emit(`uncheck`)
                } else {
                    this.$emit(`check`)
                }

                this.$emit('toggled-all')
                this.$emit('state-changed')
            },
            isExplicitlyAllSelected () {
                return (this.state.selected.length === this.state.total) || !!this.state.all
            },
            isPageSelected () {
                return this.state.registered.length > 0 &&
                    this.state.registered.reduce((left, right) => {
                        return left && this.has(right)
                    }, true)
            },
            isAllSelected () {
                return this.isExplicitlyAllSelected() || this.isPageSelected()
            },
            reset () {
                // this.$emit(`uncheck`);

                this.state.selected = []
                this.state.except = []

                this.state.all = false

                this.$emit(`reset`)
                this.$emit('state-changed')
            },
            prepare () {
                return {
                    selected: this.state.selected,
                    except: this.state.except,
                    all: this.state.all
                }
            },
            hasSelectedItem () {
                return this.state.all || this.state.selected.length > 0
            },
            hasItems () {
                return this.state.registered.length > 0
            },
            setTotal (total) {
                this.state.total = total
                this.$emit('state-changed')
            },
            setOnlyPage (value) {
                this.onlyPage = value
            }
        })
    })
}



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/helpers/selection-store.js